module.exports = __webpack_public_path__ + "6c4a0dbc/img/ion_calendar-number.3ac5bd07.svg";